import { render } from "./QuoteDetails.vue?vue&type=template&id=44dadd5a&scoped=true&ts=true"
import script from "./QuoteDetails.vue?vue&type=script&lang=ts"
export * from "./QuoteDetails.vue?vue&type=script&lang=ts"

import "./QuoteDetails.vue?vue&type=style&index=0&id=44dadd5a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dadd5a"]])

export default __exports__